<script>
import mortgagesApi from '@/api/MortgagesApi';
import Segment from '@/Segment';
import { hardRefresh } from '@/router';

const MORTGAGE_REPORT_FAILURE_MESSAGE = 'הקובץ לא עלה כמו שצריך - כדאי לבדוק שהעליתם דו”ח יתרות.';
export default {
  methods: {
    getErrorMessageForStatus(status) {
      const errorMessages = {
        BANK_CODE_NOT_FOUND: 'לא הצלחנו לזהות מאיזה בנק הדו”ח - כדאי לנסות להעלות שוב את דו”ח היתרות',
        SNPV_PARSING_ERROR: MORTGAGE_REPORT_FAILURE_MESSAGE,
        INVALID_MORTGAGE_REPORT: MORTGAGE_REPORT_FAILURE_MESSAGE,
        BANK_MISMATCH: MORTGAGE_REPORT_FAILURE_MESSAGE,
        NO_TRACKS_FOUND: 'לא מצאנו מסלולי משכנתא בקובץ — אולי זה לא הדו”ח הנכון?',
        NO_FILE_UPLOADED: 'לא הועלה קובץ — כדאי לנסות שוב',
        INVALID_PDF_FILE: 'משהו ב-PDF לא תקין - כדאי לנסות קובץ אחר',
        UNEXPECTED_ERROR: 'משהו השתבש בהעלאת הקובץ - כדאי לנסות שוב',
      };

      return errorMessages[status] || 'אירעה שגיאה בהעלאת הקובץ';
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) {
        this.isErrorMessage = true;
        this.errorMessage = 'לא נבחר קובץ';
        return;
      }

      if (file.type !== 'application/pdf') {
        this.isErrorMessage = true;
        this.errorMessage = 'ניתן להעלות רק קובצי PDF';
        this.$refs.fileInput.value = '';
        return;
      }

      this.uploadFile(file);
      // Reset the file input
      this.$refs.fileInput.value = '';
    },
    async uploadFile(file) {
      this.uploadingFile = true;
      this.isErrorMessage = false;
      try {
        // Convert file to buffer
        const arrayBuffer = await file.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);

        const response = await mortgagesApi.uploadMortgageReport(buffer, file.name);

        if (response.success) {
          Segment.trackUserInteraction('NoMortgageDataUploadPage_FileUploaded', {
            fileName: file.name,
            fileSize: file.size,
          });

          if (this.isInOtsFlow) {
            hardRefresh('/ots/mortgage');
          } else {
            hardRefresh('/mortgage');
          }
          return;
        }

        this.isErrorMessage = true;
        this.errorMessage = this.getErrorMessageForStatus(response.status);

        Segment.trackUserInteraction(`${this.pageName}_FileUploadError`, {
          fileName: file.name,
          fileSize: file.size,
          status: response.status,
        });
      } catch (error) {
        this.isErrorMessage = true;
        this.errorMessage = 'משהו לא עבד כמו שצריך, רוצה לנסות שוב?';

        Segment.trackUserInteraction(`${this.pageName}_FileUploadError`, {
          error: error.message,
          status: error.response?.status,
        });
      } finally {
        this.uploadingFile = false;
      }
    },
  },
  computed: {
  },
};

</script>
